import './quote_block.css'
